<div class="ql-container ql-snow" style="border-width: 0;">
    <div class="ql-editor" #contents [innerHTML]="content | replaceEmojis:emojiSheet:emojiFontSize:_helper.isMobile()">
    </div>
</div>